// extracted by mini-css-extract-plugin
export default {"body":"body_body__H+3Kj","body_scrolled":"body_body_scrolled__VZF39","content":"body_content__nxCRK","content_with_footer":"body_content_with_footer__78ZNG"};